import { ehFimDeSemana } from './timeline-utils.js';

interface TimelineGridProps {
  totalDias: number;
  diaPx: number;
  hojeIdx: number | null;
  dataInicio: string;
}

// Grade de fundo (fins de semana + linha "hoje") reusada por AbaGantt e
// AbaLinhaDoTempo — SPEC-UX §10.1/§10.2. Renderizada como camada absoluta
// atrás do conteúdo da linha (barras, marcos).
export function TimelineGrid({ totalDias, diaPx, hojeIdx, dataInicio }: TimelineGridProps) {
  return (
    <div className="absolute inset-0 flex" style={{ width: totalDias * diaPx }}>
      {Array.from({ length: totalDias }, (_, i) => (
        <div
          key={i}
          className={`shrink-0 border-r border-borda/60 ${ehFimDeSemana(dataInicio, i) ? 'bg-borda/25' : ''}`}
          style={{ width: diaPx }}
        />
      ))}
      {hojeIdx !== null && (
        <div className="absolute top-0 bottom-0 w-0.5 bg-aco-700" style={{ left: hojeIdx * diaPx + diaPx / 2 }} />
      )}
    </div>
  );
}
